import { render, staticRenderFns } from "./simpleSalesScreen.vue?vue&type=template&id=2daa9e1d&scoped=true"
import script from "./simpleSalesScreen.vue?vue&type=script&lang=js"
export * from "./simpleSalesScreen.vue?vue&type=script&lang=js"
import style0 from "./simpleSalesScreen.vue?vue&type=style&index=0&id=2daa9e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa9e1d",
  null
  
)

export default component.exports